/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index progress-indicator to autogenerate all the components and extensions
 * Used by "prepareProgressIndicators"
 */

import ProgressIndicator from './progress-indicator/ProgressIndicator'
export * from './progress-indicator/ProgressIndicator'
export default ProgressIndicator
